import axios from 'axios';
import { getValue } from './getValue.js';



// フォーム要素
export const archivesSelectForm = document.forms['archivesSelectForm'];

// 表示する要素
export const newsArchivesDisplaying = document.getElementById('newsArchivesDisplaying');





/**
*** セレクト要素の VALUE を取得する
***
*** @return Object
**/
export const selectValues = () => {
  // フォームエレメントを取得します
  const formElements = archivesSelectForm.elements;

  const values = {};

  // フォームエレメントをループして値を取得します
  for (let i = 0; i < formElements.length; i++) {
    // 変数の定義
    const element  = formElements[i],
          name     = element.name,
          type     = element.type,
          target   = formElements[name];
    // button 要素は処理しない
    if (type === 'button' || type === 'submit') continue;
    values[name] = getValue(target)
  };

  // ページ数
  values.page = 0;

  return values;
};





/**
*** 結果のマークアップを取得する
***
*** @return マークアップ
**/
const asyncNewsArchives = async( values ) => {
  // Appの名称（ディレクトリ名）
  const appName = newsArchivesDisplaying.dataset.name;
  const url     = `/${appName}/Request/getNewsArchives.php`;
  return axios({
    method: 'POST',
    url: url,
    headers: {'Content-Type': 'application/json'},
    data: JSON.stringify(values)
  })
  .then(function (res) {
    return res.data;
  })
  .catch(function (error) {
    console.log(error);
  });
};




/**
*** マークアップを出力する
**/
export const newsArchives = async( values = null ) => {
  if (!newsArchivesDisplaying) return;
  // 結果を受け取ります
  const result = await asyncNewsArchives(values);

  // 結果を表示します
  newsArchivesDisplaying.innerHTML = result;
};
